export function getDefaultUrl(userInfo?: any) {
  let defaultUrl = '/transactions';
  if (userInfo && userInfo.userType !== 'super_admin') {
    defaultUrl = '/transactions';
  }
  return defaultUrl;
}
